import { useEffect, useRef, useState } from 'react';
import SaveButtonBase from '../subcomponents/SaveButtonBase';
import { SaveButtonBaseProps, SaveButtonState } from '../SaveButtonProps';
import { getDataLinkEventSaveUnsave } from '../_helpers/saveButtonHelpers';
import { useComponentContext } from '../../_helpers/componentContext.tsx';

export type ComponentVariantProps = Omit<SaveButtonBaseProps, 'buttonState'> & {
	isSaved: boolean;
	clickDelay: number;
};

/**
 * Save Button variant for components (e.g.: FeaturedSeries, DCL, ArticleHeader) if the user is signed in
 * - it handles the ButtonState according to user click and item isSaved prop.
 */
const ComponentVariant: React.FC<ComponentVariantProps> = (props) => {
	const componentName = useComponentContext().componentName;
	const [buttonState, setButtonState] = useState<SaveButtonState>(
		props.isSaved ? SaveButtonState.SAVED : SaveButtonState.UNSAVED
	);
	const clickTimerRef = useRef(null);

	useEffect(() => {
		// error handling
		// if button state and saved state don't match it means that an error occurred during fetch
		if (props.isSaved === false) {
			if (
				buttonState !== SaveButtonState.UNSAVED &&
				buttonState !== SaveButtonState.UNSAVE_CLICKED
			) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				clearTimeout(clickTimerRef.current);
				setButtonState(SaveButtonState.UNSAVED);
			}
		} else if (props.isSaved === true) {
			if (
				buttonState !== SaveButtonState.SAVED &&
				buttonState !== SaveButtonState.SAVE_CLICKED
			) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				clearTimeout(clickTimerRef.current);
				setButtonState(SaveButtonState.SAVED);
			}
		}
	}, [props.isSaved]);

	const onButtonClick = () => {
		setButtonState(
			props.isSaved
				? SaveButtonState.UNSAVE_CLICKED
				: SaveButtonState.SAVE_CLICKED
		);

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		clearTimeout(clickTimerRef.current);
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		clickTimerRef.current = setTimeout(() => {
			setButtonState((prevState) => {
				if (prevState === SaveButtonState.SAVE_CLICKED) {
					return SaveButtonState.SAVED;
				}
				return SaveButtonState.UNSAVED;
			});
		}, props.clickDelay);

		props.onClick?.();
	};

	return (
		<SaveButtonBase
			{...props}
			buttonState={buttonState}
			saveDataLinkEvent={getDataLinkEventSaveUnsave(
				componentName,
				buttonState,
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				props.item
			)}
			onClick={onButtonClick}
		/>
	);
};

export default ComponentVariant;
